<template>
  <div class="flex h-6 w-full md:w-80 lg:w-full items-center pl-2">
    <keep-alive>
      <component class="w-6 md:w-8" :is="cardBrandLogo" />
    </keep-alive>
    <span v-if="card" class="flex justify-start pl-4 uppercase">
      xxxx xxxx xxxx {{card.card_last_four}}
    </span>
  </div>
</template>

<script>
import mastercardLogo from '../logos/MastercardLogo.vue';
import visaLogo from '../logos/VisaLogo.vue';
import amexLogo from '../logos/AmexLogo.vue';

export default {
  props: ['card'],

  data() {
    return {
      cardBrandLogo: null,
    };
  },

  mounted() {
    this.cardBrandLogo = `${this.card.card_brand}Logo`;
  },

  components: {
    mastercardLogo,
    amexLogo,
    visaLogo,
  },
};
</script>
